module.exports = __webpack_public_path__ + "static/img/SHANE_WATSON.ce53f5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SHANE_WATSON.jpg
// module id = gyFn
// module chunks = 0